<span class="kt-badge kt-badge--success kt-badge--inline" *ngIf="priority === 1">Low</span>
<span class="kt-badge kt-badge--warning kt-badge--inline" *ngIf="priority === 2">Medium</span>
<span class="kt-badge kt-badge--danger kt-badge--inline" *ngIf="priority === 3">High</span>